import { User } from "../user/user.model"

export enum AuditCategory {
    Injection = 'Injection',
    Creation = 'Creation',
    Assignment = 'Assignment',
    Log = 'Log',
    Offer = 'Offer',
    ProcessingDone = 'ProcessingDone',
    Refusal = 'Refusal',
    DataChange = 'DataChange',
    AutoOfferFail = 'AutoOfferFail'
}

export interface LeadAudit {
    id: number
    leadId: number
    operator: User | undefined
    initialOwner: User | undefined
    finalOwner: User | undefined
    category: string
    comment: string
    data: JSON
    updated: Date
}

